<template>
  <div>
    <div class="tracker-line">
      <span v-if="!isLoading"
            class="icon"
            :style="iconStyles"
            v-on:click="updateTracker"
            key="normalState">
        <i :class="trackerIcon"/>
      </span>
      <span v-if="isLoading"
            class="icon"
            :style="iconStyles"
            key="loadingState">
        <i class="fas fa-spinner fa-pulse"/>
      </span>
      <span v-if="loadingTrackers"
            style="color: darkgrey"
            class="icon"
            key="trackerCountLoader">
        <i class="fas fa-spinner fa-pulse"/>
      </span>
      <span v-if="!loadingTrackers" class="tracker-count">
        {{ computedTrackerCount }}
      </span>
      <input
        class="input is-small"
        type="password"
        placeholder="xxx"
        style="width: 35px"
        v-model="trackerInput"
        v-on:keyup.enter="updateTracker"/>
    </div>
    <div style="height: 5px"/>
  </div>
</template>

<script>
export default {
  name: 'TrackerLine',
  computed: {
    trackerIcon() {return "fas " + this.iconName},
    iconStyles() {
      return "border: " + this.iconColor + " solid 1px;"
        + "border-radius: 15%; color: " + this.iconColor
    },
    computedTrackerCount() {
      if(this.updatedTrackerCount > 0) return this.updatedTrackerCount;
      else return this.trackerCount;
    }
  },
  props: [
    'trackerName',
    'iconName',
    'iconColor',
    'trackerCount',
    'loadingTrackers'
  ],
  data() {
    return {
      isLoading: false,
      trackerInput: "",
      updatedTrackerCount: -1
    }
  },
  methods: {
    updateTracker() {
      /* eslint-disable no-console */
      this.isLoading = true;
      let trackUrl =
        'https://noi3mg9y29.execute-api.us-east-1.amazonaws.com/prod/track';
      this.axios
        .post(trackUrl, {
          "trackerName": this.trackerName,
          "trackerInput": this.trackerInput
        })
        .then(response => {
          console.log(response.data);
          this.updatedTrackerCount = response.data.response;
        })
        .catch(error => { console.log(error) })
        .finally(() => { this.isLoading = false })
      /* eslint-disable no-console */
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .tracker-line {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .tracker-count {
    margin: 0 10px;
  }
</style>
